import React, { useState } from "react";
import { GetMachineServiceType } from "../../../models/_tickets";
import { GetAvailableMachinesForReplaceType, GetBlendersType, GetBoardsType, GetDiagnosisType, GetLocationsType } from "../../../models/_publicCall";
import { MACHINE_SERVICES } from "../../../../_metronic/helpers/enums";
import Select from 'react-select';
import * as _ from 'lodash';
import  { Toaster } from "react-hot-toast";
import { SiteVisitationMachine } from "../SiteVisitation";
import Moment from 'moment';


const TicketsInfo = (props: {
  tickets: any;
  logJob: any;
  diagnosis: GetDiagnosisType[];
  machineServicesDB: GetMachineServiceType[];
  machinesDB: GetAvailableMachinesForReplaceType[],
  locationsDB: GetLocationsType[]
  blendersDB: GetBlendersType[],
  boardsDB: GetBoardsType[],
  replaceNewTubeDoors1mmShorter: { [ticketId: string]: boolean };
  convertTicketToLabTicket: { [ticketId: string]: boolean };
  replacedBlender: { [ticketId: string]: string };
  replacedBoard: { [ticketId: string]: string };
  siteVisitationMachines: { [machineId: string]: SiteVisitationMachine };
  keepTicketOpen: { [ticketId: string]: boolean };
  onSelectedDiagnosesChange: (selected: { [ticketId: string]: string[] }) => void;
  onSelectedMachineServicesDoneChange: (selected: { [ticketId: string]: string[] }) => void;
  onMachineServicesDoneOtherChange: (selected: { [ticketId: string]: string }) => void;
  setReplaceNewTubeDoors1mmShorter: (selected: { [ticketId: string]: boolean }) => void;
  setConvertTicketToLabTicket: (selected: { [ticketId: string]: boolean }) => void;
  setReplacedBlender: (selected: { [ticketId: string]: string }) => void;
  setReplacedBoard: (selected: { [ticketId: string]: string }) => void;
  setSiteVisitationMachines: (value: { [machineId: string]: SiteVisitationMachine }) => void;
  onDaignosisOtherChange: (selected: { [ticketId: string]: string }) => void;
  setKeepTicketOpen: (selected: { [ticketId: string]: boolean }) => void;

}) => {
  const {
    tickets,
    diagnosis,
    machineServicesDB,
    blendersDB,
    boardsDB,
    replacedBlender,
    replacedBoard,
    siteVisitationMachines,
    keepTicketOpen,
    setKeepTicketOpen,
    setReplacedBlender,
    setReplacedBoard,
    onSelectedDiagnosesChange,
    onSelectedMachineServicesDoneChange,
    onMachineServicesDoneOtherChange,
    setSiteVisitationMachines,
    onDaignosisOtherChange,
  } = props;
  
  const [selectedDiagnoses, setSelectedDiagnoses] = useState<{ [ticketId: string]: string[] }>({});
  const [selectedMachineServicesDone, setSelectedMachineServicesDone] = useState<{ [ticketId: string]: string[] }>({});
  const [machineServicesDoneOther, setMachineServicesDoneOther] = useState<{ [ticketId: string]: string }>({});
  
  const [diagnosesOther, setDiagnosesOther] = useState<{ [ticketId: string]: string }>({});

  /** Handle diagnosis checkbox changes */
  const handleCheckboxChange = (ticketId: string, diagnosisName: string) => {
    setSelectedDiagnoses((prev) => {
      const updatedDiagnoses = {
        ...prev,
        [ticketId]: prev[ticketId]?.includes(diagnosisName)
          ? prev[ticketId].filter((name) => name !== diagnosisName) // Remove if already selected
          : [...(prev[ticketId] || []), diagnosisName], // Add if not selected
      };
      onSelectedDiagnosesChange(updatedDiagnoses); // Pass updated state to parent
      return updatedDiagnoses;
    });
  };

  /** Handle machine service checkbox changes */
  const handleMachineServiceChange = (ticketId: string, serviceName: string) => {
    setSelectedMachineServicesDone((prev) => {
      const prevSelected = prev[ticketId] || [];
      const updatedSelected = prevSelected.includes(serviceName)
        ? prevSelected.filter((name) => name !== serviceName) // Remove if already selected
        : [...prevSelected, serviceName]; // Add if not selected

      const updatedState = {
        ...prev,
        [ticketId]: updatedSelected,
      };

      onSelectedMachineServicesDoneChange(updatedState); // Pass updated state to parent
      return updatedState;
    });
  };

  /** Handle "Other" service text input */
  const handleOtherServiceChange = (ticketId: string, value: string) => {
    setMachineServicesDoneOther((prev) => {
      const updated = {
        ...prev,
        [ticketId]: value,
      };

      onMachineServicesDoneOtherChange(updated); // Pass to parent
      return updated;
    });
  };
  const handleOtherDaignosisChange = (ticketId: string, value: string) => {
    setDiagnosesOther((prev) => {
      const updated = {
        ...prev,
        [ticketId]: value,
      };

      onDaignosisOtherChange(updated); // Pass to parent
      return updated;
    });
  };
 
  const [collapsedDiagnosis, setCollapsedDiagnosis] = useState(() => 
    Object.fromEntries(tickets.map((ticket: any) => [ticket.id, true]))
  );
  
  const toggleCollapse = (ticketId: string) =>
    setCollapsedDiagnosis(prev => ({ ...prev, [ticketId]: !prev[ticketId] }));
  
  const [collapsedServices, setCollapsedServices] = useState(() => 
    Object.fromEntries(tickets.map((ticket: any) => [ticket.id, true]))
  );
  
  const toggleCollapseServices = (ticketId: string) =>
    setCollapsedServices(prev => ({ ...prev, [ticketId]: !prev[ticketId] }));
  return (
    <>
      <div className="wo-form-section mt-8">
        {tickets?.length > 0 ? (
          tickets.map((ticket: any, index: number) => (
            <div key={ticket.id} className="mb-8 border-dotted border-2 border-gray-200 p-8">
              <h3>Tickets: {ticket.uuid}</h3>
              <div className="mt-4">
                {/* Machine Name */}
                {/* <div className="d-flex align-items-center gap-2">
                  <label htmlFor="machineName" className="wo-label mb-0 fw-semibold">Machine Name:</label>
                  <span className="mb-0 fw-bold">{ticket.machineName ? ticket.machineName : ticket.locationName}</span>
                </div> */}

                {/* Serial Number */}
                {/* <div className="d-flex align-items-center gap-2 mt-2">
                  <label htmlFor="serialNumber" className="wo-label mb-0 fw-semibold">Serial Number:</label>
                  <span className="mb-0 fw-bold">{ticket.serialNumber}</span>
                </div> */}

          <div className="d-flex align-items-center gap-2 mt-2">
                  <label htmlFor="serialNumber" className="wo-label mb-0 fw-semibold">Reported At:</label>
                  <span className="mb-0 fw-bold">{ticket.reportedAt ? Moment.utc(ticket.reportedAt)
                            .local()
                            .format("YYYY-MM-DD HH:mm:ss") : ''}</span>
                </div>
                {/* Serial Number */}
                <div className="d-flex align-items-center gap-2 mt-2">
                  <label htmlFor="serialNumber" className="wo-label mb-0 fw-semibold">Type:</label>
                  <span className="mb-0 fw-bold">{ticket.ticketType}</span>
                </div>
                {/* Issue Reported */}
                <div className="gap-2 mt-2">
                  <label htmlFor="issueReported" className="wo-label mb-0">Issue Reported:</label>
                  <ul className="mb-0">
                    {ticket.issuesReported.map((issue: any, index: number) => (
                      <li key={index} className="fs-5">{issue.name}</li>
                    ))}
                  </ul>
                </div>

                {/* Diagnosis */}
                <div className="gap-2 mt-2">
                <div className="d-flex align-items-center justify-content-between w-100">
                  <label htmlFor="diagnosisId" className="wo-label mb-0">
                    Diagnosis:
                  </label>
                  <button
                    type="button"
                    className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-lg border-0"
                    onClick={() => toggleCollapse(ticket.id)}
                  >
                    {collapsedDiagnosis[ticket.id] ? (
                      <i className="bi bi-chevron-down fs-2"></i>
                    ) : (
                      <i className="bi bi-chevron-up fs-2"></i>
                    )}
                  </button>
                </div>

                 {/* Collapsible Section */}
                  <div className={`ms-2 mt-2 ${collapsedDiagnosis[ticket.id] ? "d-none" : "d-block"}`}>
                    <ul className="list-unstyled">
                    {[...diagnosis, { id: "other", name: "Other" }].map((diag: GetDiagnosisType, index: number) => (
                        <label key={index} className="form-check form-check-sm form-check-custom form-check-solid me-5 d-flex align-items-center ms- mt-1">
                          <input
                            id={`diagnosis-${ticket.id}-${index}`}
                            className="form-check-input mb-2 me-1"
                            type="checkbox"
                            checked={selectedDiagnoses[ticket.id]?.includes(diag.id) || false}
                            onChange={() => handleCheckboxChange(ticket.id, diag.id)}
                          />
                          <span className="ms-2 mb-1 fs-5 form-check-label" style={{fontWeight: 'normal' }}>{diag.name}</span>
                        </label>
                      ))}
                      {selectedDiagnoses[ticket.id]?.includes("other") && (
                        <input
                          type="text"
                          className="form-control ms-2"
                          placeholder="Enter Other Diagnosis"
                          value={diagnosesOther[ticket.id] || ""}
                          onChange={(e) => handleOtherDaignosisChange(ticket.id, e.target.value)}
                        />
                      )}
                    </ul>
                  </div>
                </div>

                {/* Machine Services Done */}
                <div className=" gap-2 mt-4">
                <div className="d-flex align-items-center justify-content-between w-100">
                <label htmlFor="machineServicesDone" className="wo-label mb-0">Machine Services Done:</label>
                  <button
                    type="button"
                    className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-lg border-0"
                    onClick={() => toggleCollapseServices(ticket.id)}
                  >
                    {collapsedServices[ticket.id] ? (
                      <i className="bi bi-chevron-down fs-2"></i>
                    ) : (
                      <i className="bi bi-chevron-up fs-2"></i>
                    )}
                  </button>
                </div>
                  
                <div className={`mt-2 ${collapsedServices[ticket.id] ? "d-none" : "d-block"}`}>
                    <ul className="list-unstyled">
                      {machineServicesDB.map((service: GetMachineServiceType, index: number) => (
                        <div key={index} className="d-flex align-items-center ms-2 ">
                          <label className="form-check form-check-sm form-check-custom form-check-solid me-5 d-flex align-items-center">
                            <input
                              id={`machineServicesDone-${ticket.id}-${index}`}
                              className="form-check-input mb-2 me-1"
                              type="checkbox"
                              checked={selectedMachineServicesDone[ticket.id]?.includes(service.id) || false}
                              onChange={() => handleMachineServiceChange(ticket.id, service.id)}
                            />
                            <span className="ms-2 mb-1 fs-5 form-check-label" style={{fontWeight: 'normal' }}>{service.name}</span>
                          </label>

                          {/* Show text input when "Other" is selected */}
                          
                        </div>
                      ))}

                      {selectedMachineServicesDone[ticket.id]?.includes("other") && (
                            <input
                              type="text"
                              className="form-control ms-2"
                              placeholder="Enter service details"
                              value={machineServicesDoneOther[ticket.id] || ""}
                              onChange={(e) => handleOtherServiceChange(ticket.id, e.target.value)}
                            />
                          )}

                      

                      {selectedMachineServicesDone[ticket.id]?.includes(
                        MACHINE_SERVICES.REPLACE_BLENDER_ASSEMBLY
                      ) ? (
                        <div className="">
                          <label className="form-label required fs-4 fw-bold">
                            Blender
                          </label>
                          <Select
                            className="react-select"
                            classNamePrefix="my-react-select"
                            name="blenderId"
                            placeholder=""
                            options={Array.from(blendersDB).map((value: any) => {
                              return {
                                value: value.id,
                                label: value.title,
                              };
                            })}
                            value={{
                              label: blendersDB.find((value: any) => value.id === replacedBlender[ticket.id])?.title,
                              value: replacedBlender[ticket.id],
                            }}
                            onChange={(e: any) => {
                              setReplacedBlender({
                                ...replacedBlender,
                                [ticket.id]: e.value,
                              });
                              
                              if(siteVisitationMachines[ticket.machineId]) {
                                setSiteVisitationMachines({
                                  ...siteVisitationMachines,
                                  [ticket.machineId] : {
                                    ...siteVisitationMachines[ticket.machineId],
                                    blenderId: e.value
                                  }
                                })
                              }
                              
                            }}
                          />

                        </div>
                      ) : (
                        ""
                      )}
                      {selectedMachineServicesDone[ticket.id]?.includes(
                        MACHINE_SERVICES.UPGRADE_PCB
                      ) ||
                        selectedMachineServicesDone[ticket.id]?.includes(
                          MACHINE_SERVICES.REPLACE_PCB
                        ) ? (
                        <div className="">
                          <label className="form-label required fs-4 fw-bold">
                            Board
                          </label>
                          <Select
                            className="react-select"
                            classNamePrefix="my-react-select"
                            name="boardId"
                            placeholder=""
                            value={{
                              label: boardsDB.find((value: any) => value.id === replacedBoard[ticket.id])?.title,
                              value: replacedBoard[ticket.id],
                            }}
                            options={Array.from(boardsDB).map((value: any) => {
                              return {
                                value: value.id,
                                label: value.title,
                              };
                            })}

                            onChange={(e: any) => {
                              setReplacedBoard({
                                ...replacedBoard,
                                [ticket.id]: e.value,
                              });

                              
                            }}
                          />

                        </div>
                      ) : (
                        ""
                      )}

                     
                      
                    </ul>
                  </div>

                  <div className="">
                  <ul className="list-unstyled">
                  <li>
                      <label className="form-check form-check-sm form-check-custom form-check-solid me-5 d-flex align-items-center">
                            <input
                              id={`keep-ticket-open-${ticket.id}-${index}`}
                              className="form-check-input mb-2 me-1"
                              type="checkbox"
                              checked={keepTicketOpen[ticket.id] || false}
                              onChange={(e: any) => {
                                console.log(ticket.id, keepTicketOpen)
                                setKeepTicketOpen({
                                  ...keepTicketOpen,
                                  [ticket.id]: e.target.checked,
                                });
                              }}
                            />
                            <span className="ms-2 mb-1 fs-5 form-check-label font-semibold" style={{fontWeight: 'normal' }}>Keep this ticket open</span>
                          </label>
                      </li>
                  </ul>
                      </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <>
          </>
        )}
        <Toaster
          position="bottom-left"
          reverseOrder={false}
          gutter={8}
          containerClassName=""
          containerStyle={{}}
          toastOptions={{
            className: "",
            duration: 3000,
          }}
        />
      </div>
      
    </>
  );
};

export default TicketsInfo;
